// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AdSlot_wrapper__62ytU"};